export default "__VITE_ASSET__CYvljCC3__"